import { greetingKeys } from './constants'

import { createEventEmitter } from '../event'

export const greetingEventEmitter = createEventEmitter()

export const emitGreetingTomato = msg =>
    greetingEventEmitter.emit(greetingKeys.TOMATO, msg)

export const emitGreetingCupcake = msg =>
    greetingEventEmitter.emit(greetingKeys.CUPCAKE, msg)
